import { useLoaderData } from 'react-router';
import type { LoaderFunction, MetaFunction } from 'react-router';
import { ShopModelJSON } from '~/models'
import { ShopUseCase } from '~/usecases/shop.server'
import { MainLayout } from '~/components/templates/user/main'
import { ShopCard } from '~/components/cards'
import { getAppAssetsBaseURL } from '~/utils/application.server'
import { Header } from '~/components/compounds/user/header'
import { Footer } from '~/components/footer'
import { createMeta } from '~/utils/application'

export const meta: MetaFunction = args => createMeta({
  ...args,
  title: 'ショップ一覧',
  isShortedTitle: false,
})

type LoaderData = {
  data?: {
    shops: ShopModelJSON[]
    assetBaseURL: string
  }
  error?: Error
}

export const loader: LoaderFunction = async ({ params }) => {
  const usecase = new ShopUseCase()
  const shops = await usecase.getAllShops()
  return {
    data: {
      shops: shops,
      assetBaseURL: getAppAssetsBaseURL(),
    }
  }
}

export default function Shops() {
  const { data, error } = useLoaderData<LoaderData>()
  if (!data?.assetBaseURL) return null
  return (
    <div className="py-4">
      <div className="flex flex-row flex-wrap w-auto py-2">
        {data && data.shops.map(shop => (
          <div
            key={shop.displayID}
            className="p-2 basis-1/2 sm:basis-1/3 md:basis-1/4 flex justify-center min-w-0"
          >
            <ShopCard shop={shop} assetsBaseURL={data.assetBaseURL} />
          </div>
        ))}
      </div>
    </div>
  )
}
